import {Button} from 'antd';

import * as styles from './publication-preview-thumb.scss';

type PropsType = {
    src: string;
    onClick: VoidFunction;
};

// Clickable publication thumbnail in the promotions/events tables; opens the preview modal.
export function PublicationPreviewThumb({src, onClick}: PropsType): JSX.Element {
    return (
        <Button className={styles.PublicationPreviewThumb} onClick={onClick} type="text">
            <img alt="" className={styles.PublicationPreviewThumb_image} src={src} />
        </Button>
    );
}
